module.exports = __webpack_public_path__ + "static/media/shutterstock_127438277.71d48452.jpg";